import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Route, Switch } from "react-router-dom";
import { Loader, ViewportContext } from "@monorepo/components";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { lazyWithRetry } from "@monorepo/helpers";
import { useGetNotificationsQuery } from "@monorepo/services/api/notifications";
import theme from "@monorepo/styles/theme";
import { Typography } from "@mui/material";
import { reverse } from "named-urls";

const Notification = lazyWithRetry(() => import("components/Notifications/Notification/Notification"));

interface IProps {
  notificationId?: string;
}

export const Notifications = ({ notificationId }: IProps) => {
  const { data: notifications, isLoading: isNotificationsLoading } = useGetNotificationsQuery();
  const { isMobile } = useContext(ViewportContext);
  const { t } = useTranslation();

  return (
    <Switch>
      <Route exact path={routeConfig.dashboard.notifications.self}>
        <>
          {(!notifications || !notifications?.length) && (
            <>
              {isNotificationsLoading ? (
                <Loader />
              ) : (
                <Typography
                  variant="h6"
                  mt={2}
                  sx={{
                    color: theme.palette.text.disabled,
                  }}
                  align="center"
                >
                  {t("notifications.no_notifications")}
                </Typography>
              )}
            </>
          )}
          {notifications?.length && !isNotificationsLoading && !isMobile ? (
            <Redirect
              to={reverse(routeConfig.dashboard.notifications.notification.notificationId, {
                notificationId: notifications[0]?.id,
              })}
            />
          ) : null}
        </>
      </Route>
      <Route path={routeConfig.dashboard.notifications.notification.notificationId}>
        {notificationId ? <Notification notificationId={notificationId} /> : null}
      </Route>
    </Switch>
  );
};
